<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="2" style="text-align: left">
          <v-card color="green" dark>
            <v-col cols="12">
              <div>Active Items</div>
              <div style="font-size: 30px">
                <b>{{ gmcData.statistics.active }}</b>
              </div>
              <div>{{ parseFloat(activePercent).toFixed(2) }}%</div>
            </v-col>
          </v-card>
        </v-col>
        <v-col cols="2" style="text-align: left">
          <v-card color="orange">
            <v-col cols="12">
              <div>Expiring Items</div>
              <div style="font-size: 30px">
                <b>{{ gmcData.statistics.expiring }}</b>
              </div>
              <div>{{ parseFloat(expirePercent).toFixed(2) }}%</div>
            </v-col>
          </v-card>
        </v-col>
        <v-col cols="2" style="text-align: left">
          <v-card color="info" dark>
            <v-col cols="12">
              <div>Pending Items</div>
              <div style="font-size: 30px">
                <b>{{ gmcData.statistics.pending }}</b>
              </div>
              <div>{{ parseFloat(pendingPercent).toFixed(2) }}%</div>
            </v-col>
          </v-card>
        </v-col>
        <v-col cols="2" style="text-align: left">
          <v-card color="red" dark>
            <v-col cols="12">
              <div>Disapproved Items</div>
              <div style="font-size: 30px">
                <b>{{ gmcData.statistics.disapproved }}</b>
              </div>
              <div>{{ parseFloat(disapprovedPercent).toFixed(2) }}%</div>
            </v-col>
          </v-card>
        </v-col>
      </v-row>

      <v-data-table :headers="headers" :items="gmcData.item_issues">
        <template v-slot:item.title="{ item }">
          <template v-if="item.prioritization == 'Warning'">
            <v-icon color="orange">mdi-alert</v-icon>
          </template>
          <template v-if="item.prioritization == 'Error'">
            <v-icon color="red">mdi-alert-circle</v-icon>
          </template>
          <template v-if="item.prioritization == 'Notification'">
            <v-icon color="blue">mdi-alert-circle-outline</v-icon>
          </template>
          &nbsp;
          {{ item.title }}
        </template>
      </v-data-table>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "ItemIssueData",
  props: {
    gmcData: Object,
  },
  data: () => ({
    //total:0,
    activePercent: 0,
    expirePercent: 0,
    pendingPercent: 0,
    disapprovedPercent: 0,

    headers: [
      { text: "Issue", align: "start", value: "title", sortable: false },
      { text: "Affected Items", value: "number_of_affected_items" },
      { text: "Detail", value: "detail", sortable: false },
      { text: "Documentation", value: "documentation", sortable: false },
    ],
  }),
  methods: {
    loadData() {
      var total =
        this.gmcData.statistics.active +
        this.gmcData.statistics.expiring +
        this.gmcData.statistics.pending +
        this.gmcData.statistics.disapproved;
      this.activePercent = (this.gmcData.statistics.active / total) * 100;
      this.expirePercent = (this.gmcData.statistics.expiring / total) * 100;
      this.pendingPercent = (this.gmcData.statistics.pending / total) * 100;
      this.disapprovedPercent =
        (this.gmcData.statistics.disapproved / total) * 100;
    },
  },
  mounted() {
    console.log("ItemIssueData: ", this.gmcData);
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
</style>